/**
 * Handle newsletter popup.
 */

const newsletterPopup = function () {
	const $newsletter = $('.js-newsletter');

	if( ! $newsletter.length ){
		return;
	}

	if ( sessionStorage.getItem('hasSeenSubscribeModal') || 
		document.cookie.split(';').some((item) => item.trim().startsWith('isSubscribed'))) {
		return;
	}

	setTimeout( function() {
		$newsletter.css('display', 'flex');
	}, 8000);

	$newsletter.find('form').on('submit', function() {
		document.cookie = "isSubscribed=true; max-age=31536000";
	})

	$newsletter.find('.js-newsletter-exit').on('click', function(e) {
		e.preventDefault();

		$newsletter.hide()

		sessionStorage.setItem('hasSeenSubscribeModal', 'true')
	})
}

newsletterPopup();
